// src/app/auth.service.ts
import { Injectable } from '@angular/core';


@Injectable({
    providedIn: 'root',
})
export class AuditStatusService {


    // Set Status method
    SetStatus(status: string) {
        localStorage.setItem('SetAuditStatus', status);
    }
    getStatus() {
        return localStorage.getItem('SetAuditStatus');
    }
    

}